var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn--icon"},[_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":_vm.icon}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }